import { BillingModel } from '@/modules/billing/entities/billing.enums';
import { COMPANY_CONFIG } from '@/modules/company/entities/enums/company';
import { ComponentType } from 'react';
import { LoaderFunction } from 'react-router-dom';

import { UserType } from '@/modules/user/entities/user';

export enum APPLICATION_GROUP_BY {
  COMPANY = 'Empresa',
  BROKER = 'Corretora',
}

export type RouteMetaPermission = {
  type?: UserType;
  values?: string[];
  companyConfigs?: COMPANY_CONFIG[];
  billingModels?: BillingModel[];
};

export type RouteMetaMenu = {
  title?: string;
  name?: string;
  icon?: string;
  customImageUrl?: string;
};

export type RouteMeta = {
  title?: string;
  permission?: RouteMetaPermission;
  menu?: RouteMetaMenu;
  showApplicationMenu?: true;
  icon?: string;
  customImageUrl?: string;
  nameMenu?: string;
  pageName?: string;
  groupedBy?: APPLICATION_GROUP_BY;
};

export type Route = {
  name?: string;
  meta?: RouteMeta;
  children?: Route[];
  path?: string;
  loader?: LoaderFunction;
  index?: boolean;
  Component?: ComponentType;
  id?: string;
};

export type RouterLoaderPageDetails = {
  name?: string;
  description?: string;
  icon?: string;
  customImageUrl?: string;
  hasGoBackAction?: boolean;
  groupedBy?: APPLICATION_GROUP_BY;
  title?: string;
};
